import { useEffect, useState } from "react";
import { fetchPrivateListings } from "../services/api";

export default function usePrivateListings(filters) {
  const [data, setData] = useState({ listings: [], count: 0, total_count: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchPrivateListings(filters)
      .then((res) => {
        if (!cancelled) setData(res);
      })
      .catch((err) => {
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [JSON.stringify(filters)]);

  // Use total_count for pagination, fallback to count if not present
  return { 
    listings: data.listings, 
    count: data.total_count || data.count, 
    loading, 
    error,
    fetched_at: data.fetched_at // Include fetched_at from API response
  };
}